// Literal design-system colours (light theme) for canvas, charts and server-side rendering.
// DOM styles should use the CSS variable tokens from src/styles/tokens.ts instead.
export const LOGO_BACKGROUND_COLOR = "#0385A8";

export const APP_COLOR = "#0385A8";

export const LABEL_COLORS = {
  primary: "#0385A8",
  primaryDark: "#035D77",
  secondary: "#131313",
  secondaryDark: "#131313"
};

export const LOADER_SIZE = 15;

export const LOADER_COLOR = "#0385A8";

export const LINK_COLORS = {
  primary: "#0B6991",
  secondary: "#5F6366"
};

export const BACKGROUND_COLORS = {
  primary: "#F5F8FA",
  warning: "#FFD700"
};

export const BOX_COLORS = {
  primary: "#D6F7FF"
};

export const STATISTICS_CHART_COLORS = {
  maxSpeedChart: {
    backgroundColor: "rgba(255,81,1,1)",
    borderColor: "rgba(255,81,1,1)"
  },
  distanceChart: {
    backgroundColor: "rgba(11,105,246,1)",
    borderColor: "rgba(11,105,246,1)"
  },
  durationChart: {
    backgroundColor: "rgba(10,185,170,1)",
    borderColor: "rgba(10,185,170,1)"
  },
  avgSpeedChart: {
    backgroundColor: "rgba(255,138,76,1)",
    borderColor: "rgba(255,138,76,1)"
  }
};

export const MEDIA_QUERIES = {
  tablet_min_width: "750px",
  tablet_max_width: "1200px"
};

export const MAP_ANNOTATION_COLORS = {
  start: "#0385A8",
  end: "#F6A275",
  jibe: "rgb(158, 16, 165)",
  tack: "rgb(118, 16, 165)",
  maxSpeed: "#FF3B30"
};

/** Visual treatment for user-edited (is_user_defined) tacks/jibes on map and in lists */
export const MANUAL_MANEUVER_COLORS = {
  mapStroke: "#E8790A",
  mapMarker: "#E8790A",
  badgeBackground: "#FFF7ED",
  badgeText: "#C2410C"
};

export const ORDER_TYPES = {
  asc: "asc",
  desc: "desc"
};
